import {Injectable} from "@angular/core";
import {TimerStatus} from "./timer.config";
import {Observable} from "rxjs";
import {Observer} from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import "rxjs/add/operator/share";
import {share} from "rxjs/operators";

@Injectable()
export class Timer {

    private timerObserver: Observer<any>;
    private timeStep:number = 1000;
    private timeSpent:number = 0;
    private totalTime:number = 0;
    private type:string;
    private hardExitCountdown = false;

    // started|paused|stopped
    private status: string;
    private canInterrupt = true;
    private isTimeoutFuncDone = false;
    private timer: any;
    public timerObservable: Observable<any>;

    constructor(options: TimerOptions) {
        this.totalTime = options.totalTime;
        this.timeStep = options.timeStep || this.timeStep;
        this.type = options.type;

        this.timerObservable = new Observable(observer => {
            this.timerObserver = observer;
        }).pipe(share());
    }

    private mSecondToTime(milli: number): string {
        let minute = Math.floor(milli / 1000 / 60);
        let second = milli / 1000 - minute * 60;
        return minute + ":" + (second < 10 ? "0" + second : second);
    }

    public getTimeLeft(): number {
        let timeLeft = this.totalTime - this.timeSpent;
        return timeLeft < 0 ? 0 : timeLeft;
    }

    public start(): void {
        if (this.status !== TimerStatus.started && !this.isTimeoutFuncDone) {
            this.status = TimerStatus.started;
            this.timer = setInterval(() => {

                this.timeSpent += this.timeStep;
                this.timerObserver.next(TimerStatus.interval);
                if (!this.isTimeoutFuncDone &&
                    this.getTimeLeft() === 0 &&
                    this.canInterrupt) {
                    if (this.hardExitCountdown) {
                        this.stop();
                        this.hardExitCountdown = false;
                        this.timerObserver.next(TimerStatus.hard_exit);
                    } else {
                        this.isTimeoutFuncDone = true;
                        this.timerObserver.next(TimerStatus.timeout);
                    }
                }
                // console.log("-----------" + this.type);
                // console.log("------------------------------" + "interrupt: ", this.canInterrupt);
                // console.log("------------------------------" + "isCheckingDone: ", this.isTimeoutFuncDone);
                // console.log("------------------------------" + "isInHardExit: ", this.getHardExitCountdown());
                // console.log("------------------------------" + "currentState: ", this.status);
                // console.log("------------------------------" + this.mSecondToTime(this.getTimeLeft()));
            }, this.timeStep);
        }
    }

    public pause(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.status = TimerStatus.paused;
    }

    public stop(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timeSpent = 0;
        this.status = TimerStatus.stopped;
        this.isTimeoutFuncDone = false;
    }

    public finish(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.status = TimerStatus.stopped;
        this.isTimeoutFuncDone = true;
    }

    public restart(): void {
        this.stop();
        this.start();
    }

    public continue(): void {
        this.allowInterrupt();
    }

    public allowInterrupt(): void {
        this.canInterrupt = true;
    }

    public prohibitInterrupt(): void {
        this.canInterrupt = false;
    }

    public showTime(): string {
        // set timer displaying config according to the type of timeout dialog
        return this.mSecondToTime(this.getTimeLeft());
    }

    public setHardExitCountdown(state): void {
        this.hardExitCountdown = state;
    }

    public getHardExitCountdown(): boolean {
        return this.hardExitCountdown;
    }

    public hardExitTimer(): void {
        this.timeSpent = 0;
        this.totalTime = 2 * 60 * 1000;
        // this.totalTime = 1200;
        this.hardExitCountdown = true;
        this.restart();
    }

    public isTimerType(type: string): boolean {
        return this.type === type;
    }

    public isFinished(): boolean {
        return this.isTimeoutFuncDone;
    }

    public isStopped(): boolean {
        return this.status === TimerStatus.stopped;
    }

    public getType(): string {
        return this.type;
    }

}

export class TimerOptions {
    public timeStep:number;
    public totalTime:number;
    public type:string;
}
